module.exports = __webpack_public_path__ + "assets/img/9.67ab0a02.png";